import React from "react";
import { dateFormator, mapTableRows } from "../../../../utils";
import { Button, NewTable } from "../../../../components";
import { useNavigate } from "react-router-dom";

const ExitedEmployees = () => {
  const navigate = useNavigate();
  const tableData = [
    {
      employeeName: "Abhiram Tayi",
      employeeId: "EMP - 1003",
      employeeType: "Employee",
      payFrequency: "Monthly (W2 Payroll (Monthly))",
      paymentType: "Hourly",
      dateOfJoining: "2019-01-01T00:00:00.000Z",
      releaseDate: "2021-11-11T00:00:00.000Z",
      lastPayDay: "2021-11-11T00:00:00.000Z",
      employeeEmail: "abhiramqa@gmail.com",
    },
    {
      employeeName: "Aaron Carter",
      employeeId: "CS-2064",
      employeeType: "Consultant",
      payFrequency: "--",
      paymentType: "--",
      dateOfJoining: "2023-11-27T00:00:00.000Z",
      releaseDate: "2021-11-11T00:00:00.000Z",
      lastPayDay: "2021-11-11T00:00:00.000Z",
      employeeEmail: "abdul@tektree.com",
    },
    {
      employeeName: "Abdul Muqeeth",
      employeeId: "CON-1780",
      employeeType: "Contract",
      payFrequency: "--",
      paymentType: "--",
      dateOfJoining: "2022-09-12T00:00:00.000Z",
      releaseDate: "2025-06-23T00:00:00.000Z",
      lastPayDay: "2025-06-23T00:00:00.000Z",
      employeeEmail: "abdul@tektree.com",
    },
  ];
  const columns = [
    {
      key: "employeeName",
      label: "Employee Name",
      render: (row) => (
        <span
          className="text-info cursor-pointer"
          onClick={() => handleNavigate(row)}
        >
          {row.employeeName}
        </span>
      ),
    },
    {
      key: "employeeId",
      label: "Employee Id",
    },
    {
      key: "employeeType",
      label: "Employee Type",
    },
    {
      key: "payFrequency",
      label: "Pay Frequency",
    },
    {
      key: "paymentType",
      label: "Payment Type",
    },
    {
      key: "dateOfJoining",
      label: "Date of Joining",
      render: (row) => dateFormator(row.dateOfJoining, "month-day-year"),
    },

    {
      key: "releaseDate",
      label: "Release Date",
      render: (row) => dateFormator(row.releaseDate, "month-day-year"),
    },
    {
      key: "lastPayDay",
      label: "Last Pay Day",
      render: (row) => dateFormator(row.lastPayDay, "datetime"),
    },
    {
      key: "employeeEmail",
      label: "Employee Email",
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);

  const handleNavigate = (row) => {
    // console.log(row);
    navigate("/payroll/exit-employee");
  };

  return (
    <div>
      <NewTable
        rows={mappedRows}
        columns={columns}
        toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
        customSection={
          <div>
            <Button title={"Search"} size="sm" />
          </div>
        }
      />
    </div>
  );
};

export default ExitedEmployees;
